export default __webpack_public_path__ + "static/media/image_35.5bb43b44.png";